import { render, staticRenderFns } from "./RegisterBidderForm.vue?vue&type=template&id=0a63b0e0&scoped=true"
import script from "./RegisterBidderForm.vue?vue&type=script&lang=js"
export * from "./RegisterBidderForm.vue?vue&type=script&lang=js"
import style0 from "./RegisterBidderForm.vue?vue&type=style&index=0&id=0a63b0e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a63b0e0",
  null
  
)

export default component.exports